import { atom } from "recoil";

const userDataAtom = atom({
    key: 'userData',
    default: null
})

export default userDataAtom